module.exports = __webpack_public_path__ + "static/media/plantNine.252dd3d4.jpg";